import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { getArticle } from '../data/supportArticles';
import '../styles/SupportArticlePage.css';

function Block({ block }) {
  if (block.type === 'section') {
    return <h2 className="article-section-heading">{block.title}</h2>;
  }

  if (block.type === 'callout') {
    return (
      <div className="article-callout">
        <strong>{block.title}</strong>
        <p>{block.text}</p>
        {block.image && (
          <img src={block.image} alt={block.title} className="article-step-image" />
        )}
      </div>
    );
  }

  return (
    <div className="article-step">
      <h3 className="article-step-title">{block.title}</h3>
      {block.text && <p className="article-step-text">{block.text}</p>}
      {block.bullets && block.bullets.length > 0 && (
        <ul className="article-step-bullets">
          {block.bullets.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      )}
      {block.note && <p className="article-step-note">{block.note}</p>}
      {block.image && (
        <img
          src={block.image}
          alt={block.title}
          className="article-step-image"
        />
      )}
    </div>
  );
}

export default function SupportArticlePage() {
  const { articleSlug } = useParams();
  const article = getArticle(articleSlug);

  if (!article) {
    return (
      <div className="article-page">
        <Link to="/support" className="article-back">← Back to Support</Link>
        <h1>Article not found</h1>
        <p>The page you're looking for doesn't exist.</p>
      </div>
    );
  }

  return (
    <div className="article-page">
      <Link to="/support" className="article-back">← Back to Support</Link>
      <h1 className="article-title">{article.title}</h1>
      {article.intro && <p className="article-intro">{article.intro}</p>}
      <div className="article-blocks">
        {article.blocks.map((block, i) => (
          <Block key={i} block={block} />
        ))}
      </div>
    </div>
  );
}
